import Auth from '@jetbrains/ring-ui/components/auth/auth';
import Storage from '@jetbrains/ring-ui/components/storage/storage';
/**
 * Patching location to prevent using hash, changed by angular
 */

import AuthResponseParser from '@jetbrains/ring-ui/components/auth/response-parser';

const storedLocation = window.location.toString();

const patchAuth = () => {
  AuthResponseParser.prototype.getLocation = function getLocation() {
    return storedLocation;
  };
};

patchAuth();

const TEST_MESSAGE = 'message_passing_test';
const BLOCK_DETECTOR_TIMEOUT = 4000;

export default angular.module('installer.hub-auth-popup', []).
  // eslint-disable-next-line new-cap
  factory('hubAuthPopup', AuthInSeparateWindow => (hubState, landingUrl) => AuthInSeparateWindow(hubState, landingUrl)).
  factory('AuthInSeparateWindow', ($timeout, $window, $q) => (state, landingUrl) => {
    //console.log(state);

    const defer = $q.defer();
    let isBlocked = true;
    const w = 700;
    const h = 600;
    const left = Number((screen.width / 2) - (w / 2));
    const tops = Number((screen.height / 2) - (h / 2));

    //console.log(`${landingUrl}?serverUri=${state.hubUrl}&clientId=${state.serviceId}`);

    $window.open(`${landingUrl}?serverUri=${state.hubUrl}&clientId=${state.serviceId}`,
      '', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${tops}, left=${left}`);

    $window.addEventListener('message', function receiveMessage(event) {
      if (event.origin !== window.location.origin) {
        return;
      }
      if (event.data === TEST_MESSAGE) {
        isBlocked = false;
        return;
      }
      if (event.data.code) {
        defer.reject(event.data);
      } else {
        defer.resolve(event.data);
      }
    }, false);

    $timeout(() => {
      if (isBlocked) {
        defer.notify('blocked');
      }
    }, BLOCK_DETECTOR_TIMEOUT);

    return defer.promise;
  }).
  factory('authParamsProvider', () => {
    const key = 'HUB_VERIFY_STORE';
    const storage = new Storage();

    return routeParams => storage.get(key).then(storedState => {
      const state = {
        serverUri: routeParams.serverUri || storedState.serverUri,
        clientId: routeParams.clientId || storedState.clientId
      };

      if (!angular.equals(storedState, state)) {
        storage.set(key, state);
      }
      return state;
    });
  }).
  controller('HubAuthController', ($routeParams, $window, authParamsProvider, $q, $log) => {
    const parentWindow = ($window.opener || window.parent);
    let auth;
    parentWindow.postMessage(TEST_MESSAGE, window.location.origin);

    authParamsProvider($routeParams).then(authParams => {
      auth = new Auth({
        redirect: true,
        serverUri: authParams.serverUri,
        clientId: authParams.clientId,
        redirectUri: `${$window.location.origin + $window.location.pathname }/`
      });

      auth._storage.wipeToken();

      return auth.init();

    }).then(() => auth.requestUser()).then(user => {

      if (user.guest) {
        auth.logout({
          message: 'You are logged in as guest and guest account does not have permissions to access this service'
        });
        return $q(() => ({}));
      }
    }).then(() => auth.requestToken()).
      then(accessToken => {
        $log.debug('access token received', accessToken);

        auth.requestUser().
          // eslint-disable-next-line no-console
          then(user => console.log(user));

        parentWindow.postMessage(accessToken, window.location.origin);

        $window.close();
      }).
      catch(error => {
        $log.error(error);
        if (error.code === 'access_denied') {
          parentWindow.postMessage(error, window.location.origin);
          $window.close();
        }
      });
  });



// WEBPACK FOOTER //
// ./src/blocks/hub-auth-popup/hub-auth-popup.js